import { TextField, InputAdornment } from "@mui/material";

const TextInput = ({
  label,
  value,
  onChange,
  error,
  helperText,
  startIcon,
  endIcon,
  multiline = false,
  rows = 3,
  type = "text",
  ...props
}) => {
  return (
    <TextField
      label={label}
      value={value}
      onChange={onChange}
      error={!!error}
      helperText={error ? (typeof error === "string" ? error : helperText) : helperText}
      multiline={multiline}
      rows={multiline ? rows : undefined}
      type={type}
      fullWidth
      size="small"
      variant="outlined"
      InputProps={{
        startAdornment: startIcon && <InputAdornment position="start">{startIcon}</InputAdornment>,
        endAdornment: endIcon && <InputAdornment position="end">{endIcon}</InputAdornment>,
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          borderRadius: 3,
          backgroundColor: "#f9fafb",
          transition: "all 0.2s ease",
          "& fieldset": {
            borderColor: "#e5e7eb",
          },
          "&:hover fieldset": {
            borderColor: "#6366f1",
          },
          "&.Mui-focused fieldset": {
            borderColor: "#4f46e5",
            borderWidth: "2px",
          },
        },
      }}
      {...props}
    />
  );
};

export default TextInput;
